<template>
  <div>
    <div class="clearfix">
    <h3 class="underline clearfix pt-3">
        Erfahrung
       <b-button v-if="editMode" type="reset" :pressed.sync="editMode"  size="sm" variant="danger" class="float-right ml-3">
        abbrechen
        </b-button>
        <b-button v-if="!editMode" :pressed.sync="editMode" variant="default" class="profile_button float-right">
          <span class="bi-pencil" aria-hidden="true"></span>
        </b-button>
        <b-button v-if="editMode" @click="saveData" size="sm" variant="primary" class="float-right">
        speichern
        </b-button>
      </h3>
    </div>
    <div class="mt-3">Als Cutter tätig seit:
     <b-form-select v-model="user.since" :disabled="!editMode">
        <option v-for="year in yearValues" v-bind:key="year">{{year}}</option>
      </b-form-select>
    </div>

    <h5 class="pt-5 underline">Software</h5>
    <div v-for="index in sortedKeys(skills)" :key="index">
      <div class="row mt-3">
        <div class="col-xs-12 col-lg-4">{{ skills[index].name }}</div>
        <div class="col-xs-12 col-lg-8">
          <b-form-checkbox :disabled="!editMode"  v-model="userShowSkills[index]">im Webrofil anzeigen</b-form-checkbox>
        </div>
      </div>
    </div>
    <h5 class="pt-5 underline">Formate (Anzahl der Filme)</h5>
    <!-- weird! cant use same :key in different loops on same page(?) -->
    <div v-for="findex in sortedKeys(formats)" :key="'F'+findex">
          <div class="row mt-3">
        <div class="col-sm col-lg-4">{{ formats[findex].name }} <span class="tooltip-info" v-if="formats[findex].description" :id="tooltip(findex)"><i class="bi bi-question-circle"></i></span></div>

        <b-tooltip v-if="formats[findex].description" :target="tooltip(findex)" triggers="hover">{{formats[findex].description}}</b-tooltip>

        <div class="col-sm col-lg-8">
        <div v-if="!editMode">
         {{ userFormats[findex] ? userFormats[findex] : '0' }} {{ userFormats[findex] > 25 ? '+' : '' }}
        </div>
        <div v-if="editMode">
         <b-form-select v-model="userFormats[findex]">
           <option v-for="fv1 in formatValues" v-bind:key="fv1">{{fv1}}</option>
         </b-form-select>
         <b-form-checkbox v-model="userShowFormats[findex]">im Webrofil anzeigen</b-form-checkbox>
        </div>
        </div>
      </div>
    </div>

    <h5 class="pt-5 underline">Sprachen</h5>
     <b-form-checkbox-group v-model="userSprachen" v-if="editMode">
       <b-form-checkbox v-for="sprache in sprachen" :key="'S'+sprache.id" :value="sprache.id">{{sprache.name}}</b-form-checkbox>
     </b-form-checkbox-group>
     <div v-if="!editMode">
     <span class="text-muted" v-if="user.sprachen && user.sprachen.length===0">Keine Einträge</span>
     <span v-for="sprache in user.sprachen" :key="'US'+sprache.id">{{sprache.name}} </span>
     </div>

    <h5 class="pt-3 underline">Weitere Skills</h5>
     <b-form-checkbox-group v-model="userAdditionalSkills" v-if="editMode">
       <b-form-checkbox v-for="askill in additionalskills" :key="'AS'+askill.id" :value="askill.id">{{askill.name}}</b-form-checkbox>
     </b-form-checkbox-group>
     <div v-if="!editMode">
     <span class="text-muted" v-if="user.additionalSkills && user.additionalSkills.length===0">Keine Einträge</span>
     <span v-for="askill in user.additionalSkills" :key="'UAS'+askill.id">{{askill.name}} </span>
     </div>
    <h3 class="pt-3 underline">Persönlicher Text
    <small>(Was ist für dich Schnitt? / Philosophie)</small>
    </h3>
    <b-form-textarea id="textarea-plaintex1t" :plaintext="!editMode" :readonly="!editMode" v-model="user.personal" placeholder="nicht vorhanden"></b-form-textarea>
    <h3 class="pt-3 underline">Lieblingsspruch im Schnitt</h3>
    <b-form-textarea id="textarea-plaintext2" :plaintext="!editMode" :readonly="!editMode" v-model="user.quote" placeholder="nicht vorhanden"></b-form-textarea>
    <h3 class="pt-3 underline">Links zu Arbeitsproben</h3>
    <small>Die Links erscheinen nicht im Webprofil, sondern werden nur auf Anfrage an Kunden verschickt</small>
    <b-form-textarea id="textarea-plaintext3" :plaintext="!editMode" :readonly="!editMode" v-model="user.links" placeholder="nicht vorhanden"></b-form-textarea>

  <div class="pt-3">
   <b-button v-if="editMode" type="reset" :pressed.sync="editMode"  size="sm" variant="danger" class="float-right ml-3">
    abbrechen
    </b-button>
    <b-button v-if="editMode" @click="saveData" size="sm" variant="primary" class="float-right">
    speichern
    </b-button>
</div>
  </div>
</template>

<script>
import utils from '@/utilities'
import api from '@/api/benutzer'

export default {
  name: 'ProfilErfahrung',
  props: ['user', 'profil'],
  methods: {
    sortedKeys (obj) {
      if (obj === undefined) {
        return obj
      }
      // the vue iterator looses key order too, so we get an ordered list of keys as base for iteration
      return Object.keys(obj).sort((a, b) => obj[a]['weight'] - obj[b]['weight']).reduce(
        (accu, key) => {
          accu.push(key)
          return accu
        }, [])
    },
    tooltip (id) {
      return 'tooltip-target-' + id
    },
    toArray (commaStr) {
      if (commaStr.length > 3) {
        return commaStr.substring(1, commaStr.length - 1).split('","')
      }
      return []
    },
    rangeValues (skill, userSkill) {
      if (skill && skill.auspraegung) {
        let arr = this.toArray(skill.auspraegung)
        if (arr[userSkill]) {
          return arr[userSkill]
        }
      }
      return userSkill
    },
    async saveData () {
      let skills = []
      for (let id in this.skills) {
        let sk = {}
        sk.id = id * 1
        sk.erfahrung = this.userSkills[id] * 1
        sk.visible = this.userShowSkills[id]
        skills.push(sk)
      }
      let formats = []
      for (let id in this.formats) {
        let fmt = {}
        fmt.id = id * 1
        fmt.erfahrung = this.userFormats[id] * 1
        fmt.visible = this.userShowFormats[id]
        formats.push(fmt)
      }
      var formData = new FormData()
      formData.append('links', this.user.links)
      formData.append('quote', this.user.quote)
      formData.append('personal', this.user.personal)
      formData.append('since', this.user.since)
      formData.append('userSkills', JSON.stringify(skills))
      formData.append('userFormats', JSON.stringify(formats))
      formData.append('userSprachen', this.userSprachen)
      formData.append('userAdditionalSkills', this.userAdditionalSkills)
      await api.update(this.user.id, formData)
      let newUser = await api.get(this.user.id)
      this.$bubble('userchanged', newUser)
      this.editMode = false
    },
    updateItems (newUser) {
      if (newUser != null) {
        this.userSkills = []
        this.userShowSkills = []
        this.userSprachen = this.user.sprachen ? this.user.sprachen.map(s => s.id) : []

        let skills = newUser.skills
        if (skills) {
          for (let i = 0; i < skills.length; i++) {
            this.userSkills[skills[i].id.skillId] = skills[i].erfahrung
            this.userShowSkills[skills[i].id.skillId] = skills[i].visible
          }
        }
        this.userFormats = []
        this.userShowFormats = []
        let formate = newUser.formate
        if (formate) {
          for (let i = 0; i < formate.length; i++) {
            this.userFormats[formate[i].id.formatId] = formate[i].erfahrung
            this.userShowFormats[formate[i].id.formatId] = formate[i].visible
          }
        }
      }
    }
  },
  mounted () {
    this.updateItems(this.$props.user)
  },
  watch: {
    async editMode (val) {
      // reload user if edit is canceled
      if (!val) {
        let user = await api.get(this.user.id)
        this.$bubble('userchanged', user)
      }
    },
    // wenn der user manchmal erst geladen wird müssen schauen wann das neue user object kommt
    user: function (newUser, oldUser) {
      this.updateItems(newUser)
    }
  },
  data () {
    return {
      editMode: false,
      selectedSince: null,
      localUser: this.$store.state.auth.user,
      userSkills: [],
      userShowSkills: [],
      userSprachen: this.user.sprachen ? this.user.sprachen.map(s => s.id) : [],
      userAdditionalSkills: this.user.additionalSkills ? this.user.additionalSkills.map(s => s.id) : [],
      skills: this.$store.state.auth.baseData.skills, // die sortierreihenfolge vom server geht verloren, das muss nachgeholt werden
      yearValues: utils.yearValues(),
      formats: this.$store.state.auth.baseData.formats, // dito
      sprachen: this.$store.state.auth.baseData.sprachen, // dito
      additionalskills: this.$store.state.auth.baseData.additionalSkills, // dito
      userFormats: [],
      userShowFormats: [],
      formatValues: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 20, 25, 30, 40, 50, 75, 100, 200, 300, 400, 500, 750, 1000].reverse()
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/main/vue/components/profil/Erfahrung.vue